import "../style.css";
import "leaflet/dist/leaflet.css";
import lod_ from "lodash";
import { useEffect, useState } from "react";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import InputBoolean from "components/Custom/LittleForm/Inputs/InputBoolean";
import { useDispatch } from "react-redux";
import FormAction from "redux-react/actions/formAction";
import { Autocomplete, TextField } from "@mui/material";
import MDInput from "components/Basics/MDInput";
import { t } from "i18next";

/**
 * Final step of the shop interface form
 * @param {object} form Current form state
 * @param {Function} handleChange Function to update form state
 * @param {Function} setStepValid Function to set the step validity
 * @returns {JSX.Element} The Finish step component
 */
const ShopInterfaceFinish = ({ form, handleChange, setStepValid }) => {
	const dispatch = useDispatch();
	const [brands, setBrands] = useState([]);

	const shops = form.nearbyShops.filter(shop => form.competitorsGoogleID.includes(shop.id));

	/**
	 * Fetch available brands from the backend
	 */
	const fetchBrands = () => {
		dispatch(
			FormAction.getItemsFromCollection(
				"brand",
				{
					query: {}
				},
				res => {
					const resultBrands = res?.items || [];
					setBrands(resultBrands);
				}
			)
		);
	};

	useEffect(() => {
		fetchBrands();
		setStepValid(true);
	}, []);

	useEffect(() => {
		setStepValid(!lod_.isNil(form.brand) && !lod_.isEmpty(form.brand));
	}, [form]);

	return (
		<MDBox
			display="flex"
			flexDirection="column"
			flex="1"
			gap={2}
			sx={{
				overflowY: "auto"
			}}
		>
			{/* Active */}
			<InputBoolean
				label={t("FORMS.INTERFACE.SHOPS.active")}
				value={form.active}
				onChange={v => handleChange("active", v)}
			/>
			{/* External shop */}
			<MDBox>
				<MDTypography variant="h6">{t("FORMS.INTERFACE.SHOPS.selectedShop")}</MDTypography>
				<MDBox p={2} borderRadius="lg" border="1px solid #eee">
					<MDBox display="flex" justifyContent="space-between" alignItems="stretch">
						{/* Brand selection (replaced Select with Autocomplete) */}
						<MDBox flex="1" mr={1}>
							<Autocomplete
								fullWidth
								options={brands}
								value={brands.find(b => b.code === form.brand) || null}
								isOptionEqualToValue={(opt, val) => opt.code === val.code}
								getOptionLabel={opt => opt.name || ""}
								onChange={(e, newValue) => handleChange("brand", newValue ? newValue.code : "")}
								renderInput={params => (
									<TextField
										{...params}
										label={
											<span>
												{t("FORMS.INTERFACE.SHOPS.brand")}
												<span className="mandatoryField">*</span>
											</span>
										}
										variant="outlined"
									/>
								)}
							/>
						</MDBox>
						<MDBox flex="2">
							<MDInput
								label={t("FORMS.INTERFACE.SHOPS.shopName")}
								placeholder={t("FORMS.INTERFACE.SHOPS.shopName")}
								size="large"
								fullWidth
								value={form.name}
								onChange={e => handleChange("name", e.target.value)}
								style={{
									height: "100%"
								}}
								InputProps={{
									style: { height: "100%" }
								}}
							/>
						</MDBox>
					</MDBox>
					<MDBox mt={2}>
						{/* {form.address} */}
						<MDInput
							label={t("FORMS.INTERFACE.SHOPS.address")}
							placeholder={t("FORMS.INTERFACE.SHOPS.address")}
							size="medium"
							fullWidth
							value={form.address}
							onChange={e => handleChange("address", e.target.value)}
							style={{
								height: "100%"
							}}
							InputProps={{
								style: { height: "100%" }
							}}
						/>
					</MDBox>
				</MDBox>
			</MDBox>
			{/* Shop */}
			<MDBox>
				<MDTypography variant="h6">{t("FORMS.INTERFACE.SHOPS.competitors")}</MDTypography>
				{lod_.isEmpty(shops) && (
					<MDBox
						m={2}
						color="text"
						display="flex"
						justifyContent="center"
						alignItems="center"
						sx={{
							height: "100%"
						}}
					>
						<MDTypography variant="body2">
							{t("FORMS.INTERFACE.SHOPS.noCompetitorsSelected")}
						</MDTypography>
					</MDBox>
				)}
				<MDBox>
					{shops.map((item, key) => {
						return (
							<MDBox
								key={key}
								mb={1}
								p={2}
								borderRadius="lg"
								border="1px solid #eee"
								sx={{
									backgroundColor: "#f0f0f0"
								}}
							>
								<MDBox display="flex" justifyContent="space-between" alignItems="center">
									<MDBox fontWeight="bold">{item.displayName.text}</MDBox>
								</MDBox>
								<MDBox fontSize="0.8em" color="text">
									{item.formattedAddress}
								</MDBox>
							</MDBox>
						);
					})}
				</MDBox>
			</MDBox>
		</MDBox>
	);
};

export default ShopInterfaceFinish;
